export const MQ_FOR_PHONE = 599;
export const MQ_FOR_TABLET_LANDSCAPE = 900;
export const MQ_FOR_DESKTOP = 1800;
